<template>
  <div class="mt-2">
    <admin-toolbar /> 
    <div class="card mx-md-5 mt-3 mb-3">
      <card-header
        :title="$t('billingMethod.management')"
        :iconName="'file-earmark-text'"
      />
      <b-card-body> 
        <success-alert :showAlert="showSuccessDelete" :successMessage="$t('billingMethod.successfulDelete')" />
        <success-alert :showAlert="showSuccessEdit" :successMessage="$t('billingMethod.successfulEdit')" />
        <success-alert :showAlert="showSuccessAdd" :successMessage="$t('billingMethod.successfulAdd')" />
        <div class="card my-3" v-if="this.billingMethodForm">
          <b-card-body class="">
            <div class="row">
              <b-form-group
                id="input-group-method-name"
                :label="$t('billingMethod.methodName')"
                label-for="input-method-name"
                label-align="left"
                class="col-md-6"
              >
                <b-form-input
                  id="input-method-name"
                  v-model="billingMethod.name"
                  type="text"
                  placeholder=""
                ></b-form-input>
              </b-form-group>
              <div class="col-md-1 offset-col-md-5 my-auto">
                <b-form-checkbox v-model="active" size="lg" name="check-button" switch> {{ activeText }}   </b-form-checkbox>
              </div>
            </div>
            <div class="row ">
              <div class="col-md-6 no-padding">
                <b-form-group
                  id="input-group-rule"
                  :label="$t('billingMethod.rule')"
                  label-for="input-rule"
                  label-align="left"
                  class="col-md-12"
                > 
                  <b-form-select v-model="ruleToAdd.rule" :options="rulesList" class="mb-3">
                  </b-form-select>
                </b-form-group>
                <div class="row">
                  <b-form-group
                    id="input-group-rule"
                    :label="$t('billingMethod.billingPrice')"
                    label-for="input-rule"
                    label-align="left"
                    class="col-md-8 ml-3"
                  >
                    <b-form-input
                      id="input-rule"
                      v-model="ruleToAdd.billingValue"
                      type="number"
                      no-wheel
                      placeholder=""
                    ></b-form-input>
                  </b-form-group>
                </div>
                <div class="float-left ml-3 mb-3">
                  <b-button type="submit" variant="primary" class="mr-1" @click="addRuleToMethod">{{
                      $t("billingMethod.addRule")
                    }}</b-button>
                  <b-button type="submit" variant="primary" class="mr-1" @click="submitMethod">{{
                    $t("common.save")
                  }}</b-button>
                  <b-button type="reset" variant="warning" v-if="this.billingMethod.id == null">{{
                    $t("common.reset")
                  }}</b-button>
                </div>
              </div>
              <div class="col-md-6">
                <b-table
                  v-if="this.billingMethod != null && this.billingMethod.rules != null"
                  id="rules-table"
                  striped
                  hover
                  :items="billingMethod.rules"
                  :fields="ruleFields"
                  responsive
                  thead-class="esep-blue-bg text-light"
                  tbody-class="bg-white">

                  <template v-slot:cell(rule)="row">
                    <template v-for="rule in rulesList" >
                      <template v-if="row.item.rule == rule.value">
                       {{ rule.text }}
                      </template>
                    </template>
                  </template>

                  <template v-slot:cell(price)="row">
                    {{ row.item.billingValue / 100 }}
                  </template>

                  <template v-slot:cell(action)="row">
                    <b-button
                      size="sm"
                      @click="deleteRuleFromMethod(row.item)"
                      variant="transparent"
                      v-b-tooltip.hover
                      :title="$t('census.delete')"
                    >
                      <b-icon icon="trash"></b-icon>
                    </b-button>
                  </template>
                </b-table>
              </div>
            </div>
          </b-card-body>
        </div>
        <div class="row mb-3">
          <b-select v-model="perPage" :options="pageOptions" class="float-left col-sm-1 ml-3">
          </b-select>
          <b-button class="esep-blue-bg ml-auto mr-3" variant="primary" @click="showAddMethod">{{ $t("common.add") }}</b-button>
        </div>
        <b-table 
          v-if="this.billingMethodsList != null"
          id="billing-methods-table"
          striped
          hover
          :items="billingMethodsList"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          responsive
          thead-class="esep-blue-bg text-light"
          tbody-class="bg-white">

          <template v-slot:cell(status)="data">
            <template v-if="data.item.status == 'ACTIVE'">
              <span class="h5"> <b-icon icon="check2-square"></b-icon> </span>
            </template>
            <template v-else>
              <span class="h6 font-weight-bold">
                <b-icon icon="x-square"></b-icon>
              </span>
            </template>
          </template>

          <template v-slot:cell(action)="row">
            <b-button
              size="sm"
              @click="showEditBillingMethod(row.item)"
              variant="transparent"
              v-b-tooltip.hover
              :title="$t('census.edit')"
            >
              <b-icon icon="pencil-square"></b-icon>
            </b-button>

            <b-button
              size="sm"
              @click="deleteMethod(row.item)"
              variant="transparent"
              v-b-tooltip.hover
              :title="$t('census.delete')"
            >
              <b-icon icon="trash"></b-icon>
            </b-button>
              
          </template>
        </b-table>
        <div class="row">
          <b-col>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              align="right"
              aria-controls="members-table"
              variant="info"
            ></b-pagination>
          </b-col>
        </div>
      </b-card-body>
    </div>
  </div>
  
</template>

<script>
import CardHeader from '../../components/common/cardHeader.vue';
import SuccessAlert from '../../components/common/successAlert.vue';
import adminToolbar from '../../components/unitManagement/adminToolbar.vue';
import MemberService from "../../services/member.service";
import memberService from "@/services/member.service";
import {hasRole} from "esep/src/services/utils";
import {roles, routes} from "esep/src/services/routing.service";
import {handleApiError} from "@/services/error.service";

export default {
  computed: {
    rows() {
      return this.billingMethodsList.length;
    }
  },
  mounted() {
    memberService.getUserInfo(this.username).then(
        (response) => {
          this.userInfo = response.data;
          this.$store.state.userInfo = this.userInfo;
          if (!hasRole(this.userInfo,roles.members.unit.add)){
            location.replace(routes.nothing);
          }
          this.getBillingMethods();
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
    );

  },
  components: { adminToolbar, CardHeader, SuccessAlert },
  data() {
    return {
      ruleFields: [
        { key: "rule", label: this.$i18n.t('billingMethod.rule'), thClass: 'text-left', tdClass: 'text-left'}, 
        { key: "price", label: this.$i18n.t('billingMethod.price')},
        { key: "action", label: this.$i18n.t('billingMethod.action')}
      ],
      fields: [
        { key: "name", label: this.$i18n.t('billingMethod.name'), thClass: 'text-left', tdClass: 'text-left'}, 
        { key: "status", label: this.$i18n.t('billingMethod.status'), thClass: 'text-left', tdClass: 'text-left'},
        { key: "action", label: this.$i18n.t('billingMethod.action')}
      ],
      billingMethodsList: null,
      perPage: 10,
      currentPage: 1,
      pageOptions: [
        10,
        20,
        {
          value: Number.MAX_SAFE_INTEGER,
          text: "All",
        },
      ],
      showSuccessDelete: false,
      showSuccessAdd: false,
      showSuccessEdit: false,
      emptyBillingMethod: {
        name: null,
        rules: [],
        status: 'ACTIVE'
      },
      billingMethod: null,
      billingMethodForm: false,
      active: true,
      activeText: this.$i18n.t('billingMethod.active'),
      ruleToAdd: {
        rule: null,
        billingValue: null
      },
      rulesList: [
        {value: 'MEMBER', text: 'ΜΕΛΟΣ'},
        {value: 'NEW_MEMBER', text: 'ΝΕΟ ΜΕΛΟΣ'},
        {value: 'MEMBER_REPLACE_ID', text: 'ΑΝΤΙΚΑΤΑΣΤΑΣΗ ΤΑΥΤΟΤΗΤΑΣ ΜΕΛΟΥΣ'},
        {value: 'DISCOUNT_FIXED', text: 'ΣΤΑΘΕΡΗ ΕΚΠΤΩΣΗ'},
        {value: 'DISCOUNT_PERCENT', text: 'ΠΟΣΟΣΙΣΤΑΙΑ ΕΚΠΤΩΣΗ'},
        {value: 'DISCOUNT_PER_MEMBER', text: 'ΕΚΠΤΩΣΗ ΑΝΑ ΜΕΛΟΣ'},
        {value: 'DISCOUNT_PER_MEMBER_PERCENT', text: 'ΠΟΣΟΣΙΣΤΑΙΑ ΕΚΠΤΩΣΗ ΑΝΑ ΜΕΛΟΣ'},
        {value: 'UNIT_SPONSOR', text: 'ΕΠΙΔΟΤΗΣΗ ΣΥΣΤΗΜΑΤΟΣ'},
        {value: 'TRAINING_FEE', text: 'ΚΟΣΤΟΣ ΕΚΠΑΙΔΕΥΣΗΣ'},
        {value: 'JAMBOREE_FEE', text: 'ΚΟΣΤΟΣ ΠΑΝΕΛΛΗΝΙΑΣ ΔΡΑΣΗΣ'},
      ]
    }
  },
  watch: {
    active() {
      if(this.active) {
        this.activeText = this.$i18n.t('billingMethod.active');
      } else {
        this.activeText = this.$i18n.t('billingMethod.inactive');
      }
    }
  },
  methods: {
    getBillingMethods() {
      this.billingMethodsList = null;
      MemberService.getBillingMethodsByCriteria().then(
        response => {
          this.billingMethodsList = response.data;
          this.billingMethod = this.emptyBillingMethod;
          this.$log.debug(this.billingMethodsList);
        }
      )
    },
    deleteMethod(method) {
      MemberService.deleteBillingMethod(method.id).then(
        () => {
          window.scrollTo(0,0);
          this.showSuccessDelete = true;
          this.getBillingMethods();
        }
      );
    },
    showAddMethod() {
      window.scrollTo(0,0);
      this.billingMethod = this.emptyBillingMethod;
      this.billingMethodForm = true;
      this.ruleToAdd = {
        rule: null,
        billingValue: null
      }
    },
    submitMethod() {
      this.$log.debug(this.billingMethod);
      if(this.billingMethod.id == null) {
        MemberService.addBillingMethod(this.billingMethod).then(
          response => {
            this.billingMethod = this.emptyBillingMethod;
            this.ruleToAdd = {
              rule: null,
              billingValue: null
            }
            this.showSuccessAdd = true;
            window.scrollTo(0,0);
            this.getBillingMethods();
            this.$log.debug(response)
          }
        );
      } else {
        MemberService.editBillingMethod(this.billingMethod).then(
          response => {
            this.billingMethod = this.emptyBillingMethod;
            this.ruleToAdd = {
              rule: null,
              billingValue: null
            }
            this.showSuccessEdit = true;
            window.scrollTo(0,0);            
            this.getBillingMethods();
            this.$log.debug(response)
          }
        );
      }
      
    },
    showEditBillingMethod(method) {
      window.scrollTo(0,0);
      this.billingMethod = method;
      this.billingMethodForm = true;
      this.ruleToAdd = {
          rule: null,
          billingValue: null
        }
    },
    addRuleToMethod(){
      MemberService.addRuleToMethod(this.billingMethod.id, this.ruleToAdd).then(
          (response) => {
            this.billingMethod = response.data;
            this.ruleToAdd = {
              rule: null,
              billingValue: null
            }
          }
      );
    },
    deleteRuleFromMethod(rule) {
      for (let i = 0; i < this.billingMethod.rules.length; i++) {
        const tempRule = this.billingMethod.rules[i];
        if(rule.rule == tempRule.rule) {
          this.billingMethod.rules.splice(i,1);
        }
      }
    }
  }
}
</script>

<style>
.method-card {
  background-color: rgba(0, 0, 0, 0.15);
}

.no-padding {
    padding: 0px;
}

.btn-bg {
  color: white;
}

</style>